import React, { Component } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";

import ListHistorique from "../../components/ListHistorique";
import { columns } from "./columns";

import { loadLocations } from "../../store/actions/locationAction";
import { loadRenduAsHistorique } from "../../store/actions/renduAHistoriqueAction";

class Historique extends Component {
  componentDidMount() {
    this.props.loadLocations();
    this.props.loadRenduAsHistorique();
  }

  render() {
    const { locations, renduAsHistorique } = this.props;

    return (
      <Spin spinning={!locations || !renduAsHistorique} size="large" tip="Chargement en cours..." wrapperClassName="view-spin">
        <ListHistorique
          listData={
            renduAsHistorique &&
            renduAsHistorique.sort((a, b) => b.historique_id - a.historique_id)
          }
          locations={locations}
          tableOption={columns}
        />
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadLocations: () => dispatch(loadLocations()),
    loadRenduAsHistorique: () => dispatch(loadRenduAsHistorique()),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    locations: state.locations.data,
    renduAsHistorique: state.renduAsHistorique.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Historique);
